'use strict';

/**
 * View for rendering the list of photobox albums
 *
 * @category   View
 * @module     collection.album
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCompositeView = require('base/Colido.CompositeView');
var ListItemPhotoboxView = require('./list-item-photobox');

var template = require('../../templates/partials/list-photobox.hbs');

var ListPhotoboxView = ColidoCompositeView.extend({
    template: template,

    context: 'default',

    childView: ListItemPhotoboxView,

    childViewContainer: '#list-photobox',

    collectionEvents: {
        'add remove sync filter-complete': 'render',
    },
});

module.exports = ListPhotoboxView;